import { fg } from '@atlassian/jira-feature-gating';

export default {
	get(): boolean {
		return fg('migrate_plans_navigation_to_relay');
	},
};
